export default __webpack_public_path__ + "static/media/misc-closetB-480w.d3e1d5b7.avif";